// src/data/comedians/florence-foresti.js

const base = {
  id: 'florence-foresti',
  slug: 'florence-foresti',
  name: 'Florence Foresti',
  birthYear: 1973,
  image: require('@/assets/images/img_Florence_Foresti.jpg'),
  famousWorks: [
    'Mother Fucker',
    'Épilogue',
    'Madame Foresti',
    'Boys Boys Boys',
  ],
};

export default [
  {
    ...base,
    lang: 'en',
    nationality: 'French',
    shortBio: 'Leading female stand-up comedian in France',
    bio: `Florence Foresti is one of the most respected and successful comedians in France today. Her sharp and intelligent humor explores relationships, modern society, parenthood, and gender roles, consistently resonating with audiences across France and the French-speaking world.\n\nBorn in Lyon in 1973, Foresti developed her comedic voice through her keen observations of everyday life and relationships. Her stand-up shows blend wit with warmth, tackling subjects from marriage and motherhood to social absurdities.\n\nHer shows consistently sell out and perform extremely well on streaming platforms. She is widely regarded as a reference point for contemporary French stand-up comedy and a trailblazer for women in French comedy.`,
    style: 'Observational humor, satire, self-irony, gender and social commentary',
    achievements: [
      'Sold-out national tours',
      'High streaming viewership',
      'Most influential female comedian in France',
      'Multiple César Awards ceremony host',
    ],
  },
  {
    ...base,
    lang: 'fr',
    nationality: 'Française',
    shortBio: 'Principale comédienne de stand-up en France',
    bio: `Florence Foresti est l'une des comédienness les plus respectées et les plus populaires en France aujourd'hui. Son humour vif et intelligent explore les relations, la société moderne, la parentalité et les rôles de genre, trouvant toujours un écho auprès du public français et francophone.\n\nNée à Lyon en 1973, Foresti a développé sa voix comique à travers ses observations perspicaces de la vie quotidienne et des relations humaines. Ses spectacles stand-up mêlent esprit et chaleur, abordant des sujets allant du mariage et de la maternité aux absurdités sociales.\n\nSes spectacles font toujours salle comble et obtiennent d'excellents résultats sur les plateformes de streaming. Elle est largement considérée comme une référence du stand-up contemporain français.`,
    style: 'Humour observationnel, satire, autodérision, commentaire sur le genre et la société',
    achievements: [
      'Tournées nationales sold-out',
      'Fort taux de visionnage sur les plateformes de streaming',
      'Comédienne féminine la plus influente de France',
      'Animatrice des César à plusieurs reprises',
    ],
  },
  {
    ...base,
    lang: 'es',
    nationality: 'Francesa',
    shortBio: 'Principal comediante de stand-up femenina en Francia',
    bio: `Florence Foresti es una de las comediantes más respetadas y exitosas en Francia hoy en día. Su humor agudo e inteligente explora las relaciones, la sociedad moderna, la paternidad y los roles de género, resonando constantemente con el público francés y francófono.\n\nNacida en Lyon en 1973, Foresti desarrolló su voz cómica a través de sus agudas observaciones de la vida cotidiana y las relaciones. Sus espectáculos de stand-up mezclan ingenio y calidez, abordando temas que van desde el matrimonio y la maternidad hasta las absurdidades sociales.\n\nSus espectáculos se agotan constantemente y tienen muy buen rendimiento en plataformas de streaming. Es ampliamente considerada como un punto de referencia del stand-up contemporáneo francés.`,
    style: 'Humor observacional, sátira, autoironía, comentario de género y social',
    achievements: [
      'Giras nacionales agotadas',
      'Alta audiencia en plataformas de streaming',
      'Comediante femenina más influyente de Francia',
      'Presentadora de los César en múltiples ocasiones',
    ],
  },
  {
    ...base,
    lang: 'ar',
    nationality: 'فرنسية',
    shortBio: 'أبرز كوميديات الستاند أب في فرنسا',
    bio: `فلورانس فوريستي إحدى أكثر الكوميديات احترامًا ونجاحًا في فرنسا اليوم. فكاهتها الحادة والذكية تستكشف العلاقات والمجتمع الحديث والأبوة وأدوار الجنسين، لتجد صدىً دائمًا لدى الجمهور الفرنسي والناطق بالفرنسية.\n\nوُلدت في ليون عام 1973 وطوّرت صوتها الكوميدي عبر ملاحظاتها الثاقبة للحياة اليومية والعلاقات الإنسانية. تمزج عروضها الستاند أب بين الذكاء والدفء، متناوَلةً موضوعات تتراوح من الزواج والأمومة إلى المفارقات الاجتماعية.\n\nعروضها تُباع دائمًا بالكامل وتحقق أداءً رائعًا على منصات البث. تُعدّ على نطاق واسع مرجعًا للستاند أب الفرنسي المعاصر ورائدة للمرأة في الكوميديا الفرنسية.`,
    style: 'فكاهة ملاحظاتية، سخرية، استهزاء بالنفس، تعليق اجتماعي وجندري',
    achievements: [
      'جولات وطنية بطاقة كاملة',
      'مشاهدات عالية على منصات البث',
      'أكثر الكوميديات تأثيرًا في فرنسا',
      'مضيفة حفل César مرات عدة',
    ],
  },
];
